import { render, staticRenderFns } from "./VictoryCurriculumSUnitsPage.vue?vue&type=template&id=6cea0970&scoped=true&lang=pug&"
import script from "./VictoryCurriculumSUnitsPage.vue?vue&type=script&lang=ts&"
export * from "./VictoryCurriculumSUnitsPage.vue?vue&type=script&lang=ts&"
import style0 from "./VictoryCurriculumSUnitsPage.vue?vue&type=style&index=0&id=6cea0970&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cea0970",
  null
  
)

export default component.exports